import Button from '@global/Button'
import Image from '@global/Image'
import useEscapeKey from '@hooks/useEscapeKey'
import IconAngleLeft from '@icons/AngleLeft'
import { Link } from '@routes'
import { useState } from 'react'
import * as S from './Gallery.styled'
import GalleryMain from './GalleryMain'

const Gallery = ({
  items,
  initialSlide,
  onClose,
  floorplanIndex,
  videoIndex,
  virtualTourIndex,
  propertyInfo,
  shareInfo,
  address,
  created,
}) => {
  useEscapeKey(onClose)
  const [index, setIndex] = useState(initialSlide)
  const [isFullscreen, setIsFullscreen] = useState(false)
  const [isVideoButtonClick, setVideoButtonClick] = useState(false)

  return (
    <S.Gallery>
      <S.GalleryInnter>
        {!isFullscreen && (
          <S.GalleryInfo>
            <S.Logo hideOnMobile>
              <Link route='/' passHref>
                <Image src='/imgs/logo.svg' alt='Barryplant' />
              </Link>
            </S.Logo>
            <S.GalleryInfoHeading hideOnMobile>
              <S.BackButton onClick={onClose}>
                <IconAngleLeft /> Back
              </S.BackButton>
              <S.Count>
                {index + 1} / {items.length}
              </S.Count>
            </S.GalleryInfoHeading>
            <S.GalleryInfoBody>
              <S.GalleryInfoProperty>{propertyInfo}</S.GalleryInfoProperty>
              <S.GalleryButtons>
                {virtualTourIndex >= 0 && (
                  <Button
                    block
                    border
                    onClick={() => setIndex(virtualTourIndex)}
                  >
                    Virtual Tour
                  </Button>
                )}
                {videoIndex >= 0 && (
                  <Button
                    block
                    color='primary'
                    onClick={() => {
                      setIndex(videoIndex)
                      setVideoButtonClick(true)
                    }}
                  >
                    Video
                  </Button>
                )}
                {floorplanIndex >= 0 && (
                  <Button
                    block
                    onClick={() => setIndex(floorplanIndex)}
                    color='secondary'
                  >
                    Floorplan
                  </Button>
                )}
              </S.GalleryButtons>
              {shareInfo}
            </S.GalleryInfoBody>
          </S.GalleryInfo>
        )}
        <GalleryMain
          items={items}
          onIndexChange={(val) => {
            setIndex(val)
            if (val !== videoIndex) {
              setVideoButtonClick(false)
            }
          }}
          isVideoButtonClick={isVideoButtonClick}
          initialSlide={index}
          address={address}
          created={created}
          isInModal
          isFullscreen={isFullscreen}
          setIsFullscreen={setIsFullscreen}
          onClose={onClose}
        />
        <S.GalleryInfoHeading>
          <S.BackButton onClick={onClose}>
            <IconAngleLeft /> Back
          </S.BackButton>
          <S.Count>
            {index + 1} / {items.length}
          </S.Count>
        </S.GalleryInfoHeading>
      </S.GalleryInnter>
    </S.Gallery>
  )
}

export default Gallery
